import React, { useState } from "react";
import { APP_DOMAIN, CHOOSE_COLOR } from "../../constants/constants";
import { useHistory } from 'react-router-dom';
export  const NoResumeFound = () =>{
    const history = useHistory();
    const handleCreateResume = () => {
        history.push(CHOOSE_COLOR);
      };
    return(
        <>
            <div className="no-resume-main-container">
                <div className='create-btn'>
                    <div className="create-new-resume" onClick={handleCreateResume}>
                    <span>+ Start a New Resume</span>
                    </div>
                </div>
                <div className="list-container">
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/AI.svg`}
                                alt="AI resume assistant"
                            />
                        </div>
                        <div className="info">
                            <h3>AI resume assistant</h3>
                            <p>Get tailored writing suggestions from AI to perfectly match your resume to any job description so you’re never lost for words.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/ATS.svg`}
                                alt="Browse professional resume templates"
                            />
                        </div>
                        <div className="info">
                            <h3>Browse professional resume templates</h3>
                            <p>Select from modern, ATS-compatible templates that combine style with functionality for the modern job market.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/font-color.svg`}
                                alt="Customize your resume design"
                            />
                        </div>
                        <div className="info">
                            <h3>Customize your resume design</h3>
                            <p>Make your resume uniquely yours by adjusting fonts, colors, and layout to match your personal style.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/search.svg`}
                                alt="Find inspiration from sample resumes"
                            />
                        </div>
                        <div className="info">
                            <h3>Find inspiration from sample resumes</h3>
                            <p>Check out real resume examples across various industries to get a sense of what works best for your field.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/newATS.svg`}
                                alt="ATS-optimized layouts"
                            />
                        </div>
                        <div className="info">
                            <h3> ATS-optimized layouts</h3>
                            <p>Choose templates built to be easily read by applicant tracking systems, ensuring your resume reaches recruiters.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/personal.svg`}
                                alt="Expert tips at every step"
                            />
                        </div>
                        <div className="info">
                            <h3>Expert tips at every step</h3>
                            <p>Access professional advice and suggested phrases to refine and strengthen your resume as you build it.</p>
                        </div>
                    </div>
                </div>
                <div className='create-btn'>
                    <div className="create-new-resume" onClick={handleCreateResume}>
                    <span>+ Start a New Resume</span>
                    </div>
                </div>
            </div>
        </>
    );
}   